export const FILLER_WORDS_QUESTION =
  'How often do you catch yourself saying "um" or "uh" while speaking?'

export const FILLER_WORDS_OPTIONS = [
  { key: 'yesCantStopIt', i18nKey: 'yesCantStopIt' },
  { key: 'sometimesWhenNervous', i18nKey: 'sometimesWhenNervous' },
  { key: 'rarelyNotReally', i18nKey: 'rarelyNotReally' },
] as const

export type TFillerWordsAnswerKey = typeof FILLER_WORDS_OPTIONS[number]['key']

export const FILLER_WORDS_FEEDBACK: Record<
  TFillerWordsAnswerKey,
  { badge: string; text: string }
> = {
  yesCantStopIt: {
    badge: 'onboarding.communicationFiller.feedback.yesCantStopIt.badge',
    text: 'onboarding.communicationFiller.feedback.yesCantStopIt.text',
  },
  sometimesWhenNervous: {
    badge: 'onboarding.communicationFiller.feedback.sometimesWhenNervous.badge',
    text: 'onboarding.communicationFiller.feedback.sometimesWhenNervous.text',
  },
  rarelyNotReally: {
    badge: 'onboarding.communicationFiller.feedback.rarelyNotReally.badge',
    text: 'onboarding.communicationFiller.feedback.rarelyNotReally.text',
  },
}
